import { TeamBirthdaysTranslations } from '@/assets/locales/components/teamBirthdays/teamBirthdays.translations.en';

export const teamBirthdaysTranslations: TeamBirthdaysTranslations = {
  label: 'Urodziny',
  title: 'Zbliżające się urodziny',
  today: 'Dziś',
  tomorrow: 'Jutro',
  yesterday: 'Wczoraj',
};
